export default "__VITE_ASSET__BvC0QANm__"